/**
 * Tipos de nodes disponíveis no editor de fluxo de atendimento
 */
export enum NodeType {
  End = 'end',
  Text = 'text',
  List = 'list',
  Location = 'location',
  Event = 'event',
  Blank = 'blank',
}
